const incidentintegrationcolumn =[
  { name: " REPORT NUMBER", uid: "report_number", sortable: true },
  { name: "DEPARTMENT", uid: "department", sortable: true },
  { name: "DATE&TIME", uid: "date_time", sortable: true },
  { name: "REPORTED BY", uid: "reported_by", sortable: true },
  { name: "INCIDENT TYPE", uid: "incident_type" },
  { name: "RESPONSIBLE EMPLOYEE", uid: "witness", sortable: true },
  { name: "ACTIONS", uid: "actions" },
]
const incidentintegrationlist = [
  {
    id: 1,
    report_number: "INC001",
    department: "Manufacturing",
    date_time: "26-04-2024 08:00 AM",
    reported_by: "Olivia",
    incident_type: "Defibrillator Mishandling",
    witness: "John",
  },
  {
    id: 1,
    report_number: "INC002",
    department: "Pharmaceutical",
    date_time: "13-04-2024 12:33 PM",
    reported_by: "Olivia",
    incident_type: "Contaminated Supplies Issue",
    witness: "SMITH",
  }
]
const Studentcolumn =[
  { name: "STUDENT ID", uid: "stu_id", sortable: true },
  { name: "STUDENT NAME", uid: "stu_name", sortable: true },
  { name: "YEAR", uid: "stu_year", sortable: true },
  { name: "DEPARTMENT", uid: "stu_dept", sortable: true },
  { name: "PHONE NUMBER", uid: "stu_phone" },
  { name: "EMAIL", uid: "stu_email", sortable: true },
  { name: "ACTIONS", uid: "actions" },
]
const Studentlist = [
  {
    id: 1,
    stu_id: "STU001",
    stu_name: "Raja sekar",
    stu_year: "1",
    stu_dept: "ECE",
    stu_phone: "9845279824",
    stu_email: "rajasekar12@gmail.com",
  },
  {
    id: 2,
    stu_id: "STU003",
    stu_name: "Abinaya",
    stu_year: "2",
    stu_dept: "CSE",
    stu_phone: "7785279887",
    stu_email: "abinaya45@gmail.com",
  },
  {
    id: 3,
    stu_id: "STU034",
    stu_name: "Vijay kumar",
    stu_year: "3",
    stu_dept: "EEE",
    stu_phone: "8945679809",
    stu_email: "vijaykumar09@gmail.com",
  },
  {
    id: 4,
    stu_id: "STU065",
    stu_name: "Nantha kumar",
    stu_year: "2",
    stu_dept: "MECH",
    stu_phone: "795279835",
    stu_email: "nanthakumar34@gmail.com",
  },
]

const Canteencolumn =[
  { name: "CANTEEN NUMBER", uid: "cat_number", sortable: true },
  { name: "CANTEEN NAME", uid: "cat_name", sortable: true },
  { name: "MANAGER NAME", uid: "cat_mang", sortable: true },
  { name: "CONTACT NUMBER", uid: "cat_cont", sortable: true },
  { name: "ACTIONS", uid: "actions" },
]
const Canteenlist = [
  {
    id: 1,
    cat_number: "CAT001",
    cat_name: "Canteen 1",
    cat_mang: "Sabari Ganesh",
    cat_cont: "9835472846",
  },
  {
    id: 2,
    cat_number: "CAT002",
    cat_name: "Canteen 2",
    cat_mang: "Dinesh kumar",
    cat_cont: "8936348374",
  },
  {
    id: 3,
    cat_number: "CAT003",
    cat_name: "Canteen 3",
    cat_mang: "Gokul",
    cat_cont: "9836478947",
  },
  {
    id: 4,
    cat_number: "CAT004",
    cat_name: "Canteen 4",
    cat_mang: "Naveen sakthi",
    cat_cont: "7837485859",
  },
 
]
const Reloadcolumn =[
  { name: "STUDENT ID", uid: "re_id", sortable: true },
  { name: "STUDENT NAME", uid: "re_name", sortable: true },
  { name: "YEAR", uid: "re_year", sortable: true },
  { name: "DEPARTMENT", uid: "re_dpt", sortable: true },
  { name: "AMOUNT", uid: "re_amount", sortable: true },
  { name: "ACTIONS", uid: "actions" },
]
const Reloadlist = [
  {
    id: 1,
    re_id: "STU061",
    re_name: "Raja",
    re_year: "2",
    re_dpt: "CSE",
    re_amount: "10,000",
  },
  {
    id: 2,
    re_id: "STU043",
    re_name: "Madhesh",
    re_year: "3",
    re_dpt: "MECH",
    re_amount: "25,000",
  },
  {
    id: 3,
    re_id: "STU059",
    re_name: "Dhanam",
    re_year: "1",
    re_dpt: "AIDS",
    re_amount: "5,000",
  },
  {
    id: 4,
    re_id: "STU045",
    re_name: "Santhiya",
    re_year: "4",
    re_dpt: "IT",
    re_amount: "45,000",
  },
 
]

export {incidentintegrationcolumn,incidentintegrationlist, Studentcolumn, Studentlist, Canteencolumn, Canteenlist,
        Reloadcolumn, Reloadlist
 }